var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInsta(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.205,
    height: 35.205,
    viewBox: "0 0 35.205 35.205",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4475",
    "data-name": "Group 4475",
    transform: "translate(-658.998 -3126.975)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_34",
    "data-name": "Ellipse 34",
    cx: 3.373,
    cy: 3.373,
    r: 3.373,
    transform: "translate(673.228 3141.55)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_59",
    "data-name": "Group 59",
    transform: "translate(0 886.373)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_671",
    "data-name": "Path 671",
    d: "M37.705,24.692a3.373,3.373,0,0,0-1.946-1.946,5.622,5.622,0,0,0-1.9-.346H25.638a5.622,5.622,0,0,0-1.9.346,3.373,3.373,0,0,0-1.946,1.946,5.623,5.623,0,0,0-.346,1.9C21.4,27.676,21.4,27.979,21.4,30.7s0,3.027.043,4.109a5.623,5.623,0,0,0,.346,1.9,3.373,3.373,0,0,0,1.946,1.946,5.622,5.622,0,0,0,1.9.346h8.217a5.622,5.622,0,0,0,1.9-.346,3.373,3.373,0,0,0,1.946-1.946,5.622,5.622,0,0,0,.346-1.9c.043-1.081.043-1.384.043-4.109s0-3.027-.043-4.109a5.622,5.622,0,0,0-.346-1.9Zm-7.958,11.2a5.233,5.233,0,1,1,5.233-5.233,5.233,5.233,0,0,1-5.233,5.233ZM35.2,26.465a1.211,1.211,0,1,1,1.211-1.211A1.211,1.211,0,0,1,35.2,26.465Z",
    transform: "translate(646.854 2227.89)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_672",
    "data-name": "Path 672",
    d: "M17.6,0a17.6,17.6,0,1,0,17.6,17.6A17.6,17.6,0,0,0,17.6,0Zm10.12,22.144a7.482,7.482,0,0,1-.476,2.465,5.19,5.19,0,0,1-2.984,2.984,7.482,7.482,0,0,1-2.465.476h-8.39a7.482,7.482,0,0,1-2.465-.476,5.19,5.19,0,0,1-2.984-2.984,7.482,7.482,0,0,1-.476-2.465c-.043-1.081-.043-1.427-.043-4.2s0-3.114.043-4.2a7.482,7.482,0,0,1,.476-2.465A5.19,5.19,0,0,1,10.942,8.3a7.482,7.482,0,0,1,2.465-.432H21.8a7.482,7.482,0,0,1,2.465.476,5.19,5.19,0,0,1,2.984,2.941,7.482,7.482,0,0,1,.476,2.465c.043,1.081.043,1.427.043,4.2S27.766,21.062,27.723,22.144Z",
    transform: "translate(658.998 2240.603)",
    fill: "#fff"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.323214388f5f606702230de230aad0b5.svg";
export { ForwardRef as ReactComponent };